import React from 'react';
import {
  Table,
  InputGroup,
  FormGroup,
  FormControl,
  Pager
} from 'react-bootstrap';
import { observer, inject } from 'mobx-react';
import TableHeaderControl from './TableHeaderControl';
import { Switch, Route, Link } from 'react-router-dom';
import StartupModal from './StartupModal';
import { injectIntl } from 'react-intl';
@injectIntl
@inject('growStore')
@observer
export default class StartupsInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, active: -1 };
  }

  openModal(idx) {
    this.setState({ isOpen: !this.state.isOpen, active: idx });
  }

  render() {
    const { growStore, intl } = this.props;

    const title = {
      name: intl.formatMessage({ id: 'startup_name_label' }),
      consecutiveDays: intl.formatMessage({
        id: 'consecutive_days_login_label'
      }),
      lastLogin: intl.formatMessage({ id: 'last_login_label' }),
      monthlyLoginCount: intl.formatMessage({ id: 'monthly_login_label' }),
      totalLoginCount: intl.formatMessage({ id: 'total_login_label' })
    };

    const cmp = growStore.getComparisonCriteria;

    const startupTotal = growStore.totalStartup;
    const startupActive = growStore.activeStartup;

    return (
      <div>
        <Route
          exact
          path="/startup_statistics/grow/show/:id"
          render={props => <StartupModal {...props} />}
        />

        <form
          style={{
            marginTop: '15px',
            width: '80%',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <FormGroup>
            <InputGroup>
              <InputGroup.Addon>
                <i className={'fa fa-search'} />
              </InputGroup.Addon>
              <FormControl
                placeholder={intl.formatMessage({
                  id: 'searchbar_placeholder'
                })}
                type="text"
                value={growStore.filterText}
                onChange={e => {
                  growStore.setFilterText(e.target.value);
                }}
              />
            </InputGroup>
          </FormGroup>
        </form>

        <Table
          striped
          responsive
          style={{ marginTop: 25, textAlign: 'center' }}
        >
          <thead>
            <tr>
              <th style={{ textAlign: 'center' }}>
                {intl.formatMessage({ id: 'total_startups_label' })}
              </th>
              <th style={{ textAlign: 'center' }}>
                {intl.formatMessage({ id: 'active_startups_label' })}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>{startupTotal}</td>
              <td>{startupActive}</td>
            </tr>
          </tbody>
        </Table>

        <Table striped responsive>
          <thead>
            <tr>
              {Object.keys(title).map((e, id) => {
                return (
                  <TableHeaderControl
                    title={title}
                    growStore={growStore}
                    cmp={cmp}
                    query={e}
                    key={id}
                  />
                );
              })}
            </tr>
          </thead>

          <tbody>
            {growStore.retrieveStartups.length > 0 ? (
              growStore.retrieveStartups.map((p, idx) => {
                return (
                  <tr key={idx}>
                    <td>
                      <Link to={'/startup_statistics/grow/show/' + p.id}>
                        {p.name}
                      </Link>
                    </td>
                    <td>{p['consecutive_days_login']}</td>
                    <td>{p['last_login']}</td>
                    <td>{p['monthly_login']}</td>
                    <td>{p['total_login']}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', fontSize: 30 }}>
                  {intl.formatMessage({ id: 'no_results_message' })}
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <Pager>
          <Pager.Item
            previous
            onClick={() => growStore.prevStartups()}
            disabled={growStore.disablePrevStartups}
          >
            {intl.formatMessage({ id: 'pager_previous_label' })}
          </Pager.Item>
          <Pager.Item
            next
            onClick={() => growStore.nextStartups()}
            disabled={growStore.disableNextStartups}
          >
            {intl.formatMessage({ id: 'pager_next_label' })}
          </Pager.Item>
        </Pager>
      </div>
    );
  }
}
